import {
    Datagrid,
    DateInput,
    SimpleList,
    TextField,
    DateField,
    ReferenceField,
    useGetList,
    FunctionField,
} from 'react-admin';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme } from '@mui/material';
import { GenerateButton } from '@components/GenerateButton';
import { entityResource as ent } from '@src/entityResource';
import { shortOptions, shortOptionsWithTime } from '@src/helpers/date.ext';
import env from '@src/environment';

const filters = [
    <DateInput
        key="visitDate"
        source="visitDate"
        alwaysOn
        variant="standard"
        sx={{ debounce: 3000 }}
    />,
];

export const ScheduleList = () => {
    const { total } = useGetList(ent.STORE.NAME);
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    return (
        <InfiniteList
            generateButton={<GenerateButton total={total} />}
            filtersNodes={filters}
        >
            {isSmall ? (
                <SimpleList
                    primaryText={record => (
                        <ReferenceField source="userId" reference="users">
                            <TextField source="name" />
                        </ReferenceField>
                    )}
                    secondaryText={record => (
                        <ReferenceField source="storeId" reference="store">
                            <TextField source="name" />
                        </ReferenceField>
                    )}
                    tertiaryText={record => <DateField source="visitDate" />}
                />
            ) : (
                <Datagrid>
                    <ReferenceField source="userId" reference="users">
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField source="storeId" reference="store">
                        <TextField source="name" />
                    </ReferenceField>
                    <DateField
                        source="visitDate"
                        locales={env.localFormat}
                        options={shortOptions}
                    />
                    <TextField source="attendanceMethod" />
                    <DateField
                        source="checkinDate"
                        locales={env.localFormat}
                        options={shortOptionsWithTime}
                    />
                    <DateField
                        source="checkoutDate"
                        locales={env.localFormat}
                        options={shortOptionsWithTime}
                    />
                    <FunctionField
                        source="distance"
                        render={record =>
                            record.distance
                                ? `${record.distance} km`
                                : undefined
                        }
                    />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
